
export default () => {
	const toggle = document.querySelector('.js-toggle-filters-mobile')
	const toggleText = toggle?.querySelector('span')
	const content = document.querySelector('.js-toggle-filters-mobile__content')
	if (!toggle || !toggleText || !content) return

	let isOpen = false
	toggle.addEventListener('click', () => {
		if (isOpen) {
			content.classList.remove('show')
			isOpen = false
			toggleText.innerHTML = 'Show filters'
		} else {
			content.classList.add('show')
			isOpen = true
			toggleText.innerHTML = 'Hide filters'
		}
	})
}